import { TaxonomyLanguages } from 'app/types/editor-taxonomy';

export const getTagLabel = ({ languages, currentLang }: { languages: TaxonomyLanguages; currentLang: keyof TaxonomyLanguages }) => {
  const langObj = languages[currentLang] || languages['en'];
  let label: string | null = null;
  if (langObj) {
    label = langObj.label ?? langObj.terseLabel ?? langObj.verboseLabel ?? null;
  }
  // Remove any brackets and their content
  if (label) {
    label = label.replace(/\s*\[.*?\]\s*/g, '').trim();
  }
  return label;
};
